module.exports = __webpack_public_path__ + "img/saimage1.cde959c8.jpg";